import { render } from "./sticky-header.vue?vue&type=template&id=05be7b6f&scoped=true"
import script from "./sticky-header.vue?vue&type=script&lang=js"
export * from "./sticky-header.vue?vue&type=script&lang=js"

import "./sticky-header.vue?vue&type=style&index=0&id=05be7b6f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05be7b6f"]])

export default __exports__